import { Injectable } from '@angular/core';
import { WizardStepDto, WizardStepStage } from '../models/client-models/entities/wizard-step-dto';
import { CompletenessStatus } from '../models/client-models/enums/completeness-status';

@Injectable({ providedIn: 'root' })
export class WizardStepService {
  getWizardSteps(): WizardStepDto[] {
    return [
      {
        status: CompletenessStatus.Active,
        name: { en: 'Print variation', ge: 'სერვისი', ru: 'Сервис' },
        description: {
          en: 'Select your preferred service',
          ge: 'აირჩიეთ სასურველი სერვისი',
          ru: 'Выберите предпочитаемый сервис',
        },
        explanation: {
          en: 'Try to select the most suitable service for your needs, if none of the services are suitable, select General Print',
          ge: 'თუ ჩამოთვლილთაგან არცერთი შეესაბამება თქვენს მოთხოვნილს, გთხოვთ აირჩიოთ ზოგადი ბეჭდვა',
          ru: 'Выберите наиболее подходящий сервис для ваших потребностей, если ни один из сервисов не подходит, выберите Общая печать',
        },
        stage: WizardStepStage.VariationSelection,
        hasOptionSelected: false,
        isOptional: false,
        isBackButtonHidden: true,
      },
      {
        status: CompletenessStatus.None,
        name: { en: 'Paper size', ge: 'ქაღალდის ზომა', ru: 'Размер бумаги' },
        description: {
          en: 'Select your preferred size',
          ge: 'აირჩიეთ სასურველი ზომა',
          ru: 'Выберите предпочитаемый размер',
        },
        stage: WizardStepStage.PaperSizeSelection,
        hasOptionSelected: false,
        isOptional: false,
      },
      {
        status: CompletenessStatus.None,
        name: { en: 'Paper type', ge: 'ქაღალდის ტიპი', ru: 'Тип бумаги' },
        description: {
          en: 'Select your preferred paper type',
          ge: 'აირჩიეთ სასურველი ტიპი',
          ru: 'Выберите предпочитаемый тип',
        },
        stage: WizardStepStage.PaperTypeSelection,
        hasOptionSelected: false,
        isOptional: false,
      },
      {
        status: CompletenessStatus.None,
        name: { en: 'Print Style', ge: 'ბეჭდვის სტილი', ru: 'Стиль печати' },
        description: {
          en: 'Select paper attributes',
          ge: 'აირჩიეთ ქაღალდის მახასიათებლები',
          ru: 'Выберите атрибуты бумаги',
        },
        stage: WizardStepStage.PrintStyleSelection,
        hasOptionSelected: false,
        isOptional: false,
      },
      {
        status: CompletenessStatus.None,
        name: { en: 'Extras', ge: 'დამატებითი სერვისები', ru: 'Дополнительные услуги' },
        description: {
          en: 'Select additional features',
          ge: 'აირჩიეთ დამატებითი ფუნქციები',
          ru: 'Выберите дополнительные функции',
        },
        stage: WizardStepStage.ExtrasSelection,
        hasOptionSelected: false,
        isOptional: true,
      },
      {
        status: CompletenessStatus.None,
        name: { en: 'Files', ge: 'ფაილები', ru: 'Файлы' },
        description: { en: 'Upload files', ge: 'ატვირთეთ ფაილები', ru: 'Загрузите файлы' },
        stage: WizardStepStage.FilesSelection,
        hasOptionSelected: false,
        isOptional: true,
      },
      {
        status: CompletenessStatus.None,
        name: { en: 'Print office', ge: 'ბეჭდვის ოფისი', ru: 'Типография' },
        description: { en: 'Select print office', ge: 'აირჩიეთ ბეჭდვის ოფისი', ru: 'Выберите типографию' },
        explanation: {
          en: 'To view details, please click on the print office',
          ge: 'დეტალების სანახავად დააჭირეთ სასურველ ოფისს',
          ru: 'Для просмотра деталей, пожалуйста, нажмите на типографию',
        },
        stage: WizardStepStage.PrintOfficeSelection,
        hasOptionSelected: false,
        isOptional: false,
      },
      {
        status: CompletenessStatus.None,
        name: { en: 'Payment', ge: 'გადახდა', ru: 'Оплата' },
        description: { en: '', ge: '', ru: '' },
        stage: WizardStepStage.Payment,
        hasOptionSelected: false,
        isOptional: false,
        isNextButtonHidden: true,
      },
    ];
  }
}
